const contextMenu = {
  colors: "Colors",
  backgroundColor: "Background",
  textColor: "Text",
  textHighlight: "Highlight",
  borderColor: "Border",
  typography: "Typography",
  fontFamily: "Font",
  fontSize: "Size",
  letterSpacing: "Letter Spacing",
  lineHeight: "Line Height",
  textContent: "Text Content",
  resetElement: "Reset Element",
  resetAll: "Reset All",
  openPicker: "Open Color Picker",
  transparent: "Transparent",
  overridesSection: "Element Overrides",
  overridesHint: "Right-click any element to customize",
  systemDefault: "System Default",
  myCustom: "My Custom",
  nameHistory: "Name History",
  noHistory: "No history",
  originalName: "Original Name",
  restoreName: "Restore Name",
} as const;
export default contextMenu;
